import { throttle } from '../Helper/helper';

document.addEventListener('DOMContentLoaded', function() {
  let checkIntervalMove, checkIntervalDisplay;

  const moveLivezillaButton = throttle(function() {
    const LIVEZILLA_BUTTON = $('#lz_overlay_wm');
    const TARGET_DIV = $('#chat-livezilla');

    if (LIVEZILLA_BUTTON.length > 0 && TARGET_DIV.length > 0) {
      TARGET_DIV.append(LIVEZILLA_BUTTON);
      clearInterval(checkIntervalMove);
      // make it visible after it has been moved to the right dom element
      LIVEZILLA_BUTTON.addClass('opacity-100');
    }
  }, 500);

  const displayLivezillaButton = throttle(function() {
    const LIVEZILLA_BUTTON = $('#lz_overlay_wm');
    const CHAT_BUTTON = $('.site-popup__contact-button-chat');

    if (LIVEZILLA_BUTTON.length > 0 && LIVEZILLA_BUTTON.css('display') !== 'none') {
      console.log('LiveZilla button is displayed');
      CHAT_BUTTON.show();
      $('[data-include-chat="1"]').attr('data-chat-ready', '1');
      clearInterval(checkIntervalDisplay);
    }

    CHAT_BUTTON.on('click', function() {
      if (typeof _paq !== 'undefined') {
        _paq.push(['trackEvent', 'Chat', 'Click', 'LiveZilla']);
      }
    });
  }, 1000);

  // Set up an interval to repeatedly check for the LiveZilla button is available
  checkIntervalMove = setInterval(moveLivezillaButton, 500);

  // Set up an interval to repeatedly check for the LiveZilla button is finally displayed
  checkIntervalDisplay = setInterval(displayLivezillaButton, 1000);
});
